import React from "react";
import PageHeader from "../../components/PageHeader";
import EmailIcon from '@mui/icons-material/Email';
import ContactForm from "../../components/ContactForm";
const Contact = () =>{
    return(
        <>
            <PageHeader title="CONTACT" description="Shoot me a message with your inquiries and I connect with you." />
            <div className="container-full-width border-top py-5">
                <div className="row">
                    <div className="col-md-6">
                        <h2 style={{'fontWeight':'300'}} className="">LET'S WORK TOGETHER.</h2>
                        <p style={{'fontWeight':'300', 'fontSize':'24px'}} >I would love to discuss your next dream project with you.</p>
                        <p className="display-6 my-0"><a className="text-underline" href="mailto: sudarshanhang@gmail.com">Email:sudarshanhang@gmail.com</a></p>
                    </div>
                    <div className="col-md-6">
                        
                        <div className="formcarry-container">
                            <ContactForm />
                        </div>

                    </div>

                </div>
             
            </div>
        </>

    );
}

export default Contact;
